// extracted by mini-css-extract-plugin
module.exports = {"preview":"Js3pR","inner":"cc7BF","title":"rrQi8","link":"Qq0KW","subtitle":"NkpIJ","block":"o2WD7","more":"GXjbZ","footer":"iGPTJ"};